var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "table-toolbar d-flex align-center"
  }, [_vm.searchProductCompletion ? _c('TableSearchProductAutocomplete', {
    ref: "searchProductField",
    attrs: {
      "placeholder": _vm.searchPlaceholder,
      "search-params": _vm.productSearchParams,
      "exclude-product-ids": _vm.excludeProductIds,
      "autofocus": _vm.autofocus
    },
    on: {
      "product-select": function productSelect($event) {
        return _vm.$emit('product-select', $event);
      }
    }
  }) : _vm.hasSearch ? _c('v-text-field', {
    ref: "searchField",
    staticClass: "table-toolbar__search flex-grow-1",
    "class": {
      'table-toolbar__search--filled': _vm.isSearchFilled
    },
    attrs: {
      "value": _vm.searchValue,
      "dense": "",
      "outlined": "",
      "hide-details": "",
      "single-line": "",
      "clearable": "",
      "prepend-inner-icon": "mdi-magnify",
      "placeholder": _vm.searchPlaceholder,
      "aria-label": _vm.searchPlaceholder,
      "autofocus": _vm.autofocus
    },
    on: {
      "input": _vm.onSearchInput
    }
  }) : _vm._e(), _c('div', {
    staticClass: "table-toolbar__actions d-flex align-center flex-shrink-0 ml-2"
  }, [_vm.hasFilters ? _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c('button', _vm._g(_vm._b({
          staticClass: "table-toolbar__action",
          "class": {
            'table-toolbar__action--active': _vm.filtersPanelOpen
          },
          attrs: {
            "type": "button",
            "aria-label": _vm.$translate('toggleFilters'),
            "aria-pressed": _vm.filtersPanelOpen
          },
          on: {
            "click": function click($event) {
              return _vm.$emit('toggle-filters');
            }
          }
        }, 'button', attrs, false), on), [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("mdi-tune-variant")]), _vm.hasActiveFilters ? _c('span', {
          staticClass: "table-toolbar__badge-dot",
          attrs: {
            "aria-hidden": "true"
          }
        }) : _vm._e()], 1)];
      }
    }], null, false, 3033595803)
  }, [_c('span', [_vm._v(_vm._s(_vm.filtersPanelOpen ? _vm.$translate("hideFilters") : _vm.$translate("toggleFilters")))])]) : _vm._e(), _vm.viewsScope ? _c('TableViewsMenu', {
    ref: "viewsMenu",
    attrs: {
      "views-scope": _vm.viewsScope,
      "filters": _vm.filters,
      "views-exclude-keys": _vm.viewsExcludeKeys,
      "active": _vm.viewsMenuOpen,
      "has-active-view": _vm.hasActiveView
    },
    on: {
      "toggle": function toggle($event) {
        return _vm.$emit('toggle-views');
      },
      "apply": function apply($event) {
        return _vm.$emit('view-apply', $event);
      },
      "reset": function reset($event) {
        return _vm.$emit('view-reset');
      },
      "active-view-change": function activeViewChange($event) {
        return _vm.$emit('active-view-change', $event);
      }
    }
  }) : _vm._e(), _vm.enableColumnManagement && _vm.columns.length ? _c('TableColumnsMenu', {
    attrs: {
      "columns": _vm.columns,
      "column-state": _vm.columnState,
      "active": _vm.columnsMenuOpen,
      "customized": _vm.columnsCustomized
    },
    on: {
      "toggle": function toggle($event) {
        return _vm.$emit('toggle-columns');
      },
      "change": function change($event) {
        return _vm.$emit('columns-change', $event);
      },
      "reset": function reset($event) {
        return _vm.$emit('columns-reset');
      }
    }
  }) : _vm._e()], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }